import React, { useState } from "react";
import ProfileFieldCard from "../../../component/ProfileFieldCard";
import { Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../State/Store";
import { updateUserProfile } from "../../../State/AuthSlice";

const UserDetails = () => {
    const { auth } = useAppSelector(store => store);
    const dispatch = useAppDispatch();
    
    const [openModal, setOpenModal] = useState(false);
    const [formData, setFormData] = useState({
        fullName: auth.user?.fullName || "",
        mobile: auth.user?.mobile || "",
    });

    const handleOpen = () => {
        setFormData({
            fullName: auth.user?.fullName || "",
            mobile: auth.user?.mobile || "",
        });
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        dispatch(updateUserProfile(formData));
        setOpenModal(false);
    };

    return (
        <div className='flex justify-center py-10'>
            <div className='w-full lg:w-[70%]'>
                <div className='flex items-center pb-3 justify-between'>
                    <h1 className='text-2xl font-bold text-gray-600'>Personal Details</h1>
                    <Button variant="outlined" size="small" onClick={handleOpen}>
                        Edit Details
                    </Button>
                </div>
                
                <div className=''>
                    <ProfileFieldCard keys='Name' value={auth.user?.fullName || ""}/>
                    <Divider/>
                    <ProfileFieldCard keys='Email' value={auth.user?.email || ""}/>
                    <Divider/>
                    <ProfileFieldCard keys='Mobile' value={auth.user?.mobile || ""}/>
                </div>

                {/* Edit Modal */}
                <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="xs">
                    <DialogTitle>Edit Personal Details</DialogTitle>
                    <DialogContent className="space-y-4 pt-2">
                        <TextField
                            fullWidth
                            label="Full Name"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Mobile Number"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="inherit">Cancel</Button>
                        <Button onClick={handleSubmit} variant="contained">Save</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default UserDetails;